import { render, staticRenderFns } from "./BarraDeMenuPrincipal.vue?vue&type=template&id=5d8da978&scoped=true"
import script from "./BarraDeMenuPrincipal.vue?vue&type=script&lang=js"
export * from "./BarraDeMenuPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8da978",
  null
  
)

export default component.exports